import { SVGProps } from 'react';

export default function Delivery2(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2313_3172)">
        <path
          d="M12.5 14.9997H3.33333C2.44928 14.9997 1.60143 14.6485 0.976311 14.0234C0.35119 13.3982 0 12.5504 0 11.6663V4.99967C0 3.89461 0.438987 2.8348 1.22039 2.0534C2.00179 1.27199 3.0616 0.833008 4.16667 0.833008H8.33333C8.88051 0.833008 9.42232 0.940782 9.92785 1.15018C10.4334 1.35957 10.8927 1.66649 11.2796 2.0534C11.6665 2.44031 11.9734 2.89964 12.1828 3.40516C12.3922 3.91068 12.5 4.4525 12.5 4.99967V14.9997ZM20 9.16634V8.33301C20 7.78583 19.8922 7.24402 19.6828 6.73849C19.4734 6.23297 19.1665 5.77364 18.7796 5.38673C18.3927 4.99982 17.9334 4.6929 17.4278 4.48351C16.9223 4.27412 16.3805 4.16634 15.8333 4.16634H14.1667V9.16634H20ZM14.1667 10.833V14.9997H16.6667C17.5507 14.9997 18.3986 14.6485 19.0237 14.0234C19.6488 13.3982 20 12.5504 20 11.6663V10.833H14.1667ZM3.38167 16.6663C3.35114 16.8032 3.33494 16.9428 3.33333 17.083C3.33333 17.6355 3.55283 18.1654 3.94353 18.5561C4.33423 18.9468 4.86413 19.1663 5.41667 19.1663C5.9692 19.1663 6.4991 18.9468 6.88981 18.5561C7.28051 18.1654 7.5 17.6355 7.5 17.083C7.49839 16.9428 7.48219 16.8032 7.45167 16.6663H3.38167ZM12.5483 16.6663C12.5178 16.8032 12.5016 16.9428 12.5 17.083C12.5 17.6355 12.7195 18.1654 13.1102 18.5561C13.5009 18.9468 14.0308 19.1663 14.5833 19.1663C15.1359 19.1663 15.6658 18.9468 16.0565 18.5561C16.4472 18.1654 16.6667 17.6355 16.6667 17.083C16.6651 16.9428 16.6489 16.8032 16.6183 16.6663H12.5483Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2313_3172">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
